import { Box, Flex, BoxProps, useColorModeValue } from '@chakra-ui/react';
import { SidebarCollapsibleItem } from './SidebarCollapsibleItem';
import { getAllRoutes } from 'src/app/routes/utils';
import { MerkatusLogo } from 'src/components/atoms/MerkatusLogo';
import { useActiveRoute } from 'src/hooks/useActiveRoute';
import { useInboxUnreadCountQuery } from 'src/api/inboxes';
import { useAppContext } from 'src/contexts/AppContext';

export const SidebarContent = ({ ...rest }: BoxProps) => {
  const { activeRoute } = useActiveRoute();
  const { currentCustomer } = useAppContext();
  const { data: unreadCount } = useInboxUnreadCountQuery(
    currentCustomer?.customerName ?? '',
  );

  return (
    <Box
      transition="3s ease"
      bg="surface.sidebar"
      borderRight="1px"
      borderRightColor="border.layout"
      w={{ base: 'full', md: '340px' }}
      pos="fixed"
      overflowY="auto"
      paddingBottom={16}
      h="full"
      zIndex={10}
      {...rest}>
      <Flex h="20" alignItems="center" mx="8" justifyContent="space-between">
        <MerkatusLogo theme={useColorModeValue('dark', 'white')} />
      </Flex>
      {getAllRoutes().map((route) => {
        const isRouteActive = activeRoute?.url === route.url;
        const isInboxRoute = route.url === '/inbox';
        return (
          <SidebarCollapsibleItem
            key={route.url}
            icon={route.icon}
            route={route}
            isActive={isRouteActive}
            badgeCount={isInboxRoute ? unreadCount : undefined}
          />
        );
      })}
    </Box>
  );
};
